module.exports = __webpack_public_path__ + "img/wei2.d1153c65.png";